import UserEntityMemberInvitation from "legal-entities/invitations/member-invitations/email-based/user-entity-member-invitation";

export default class CreateUserEntityMemberInvitationAPIRequest {
  public readonly inviteeEmail: string;
  public readonly firstName?: string;
  public readonly lastName?: string;

  public constructor(invitation: UserEntityMemberInvitation) {
    if (!invitation.registrationInfo?.email) {
      throw new Error("Registration info email is required to create an Entity Member Invitation.");
    }

    this.inviteeEmail = invitation.registrationInfo.email.value;
    this.firstName = invitation.registrationInfo.name?.firstName;
    this.lastName = invitation.registrationInfo.name?.lastName;
  }
}
